import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { CurrencyPipe } from '../../filters/currency.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { InputDatepickerComponent } from '../../components/input-datepicker/input-datepicker.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ServiceRestServices from '../../services/service-rest.service';
import Session from '../../utils/session.service';
import CategoryService from '../../services/category.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'table-transactions',
	templateUrl: './table-transactions.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe,
		CurrencyPipe, TranslatePipe, ItemNoContentComponent,
		InputDatepickerComponent, LoaderOverlayComponent, FormsModule
	]
})
export class TableTransactionsComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private categoryService: CategoryService = inject(CategoryService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() showIncomeOnly: any | undefined;
	@Input() transactions: any;
	@Output() transactionsChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.uid = 'tt-' + Date.now();
		this.vm.element = '#' + this.vm.uid;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.vm.filterData = {};
		
		this.categoryService.initialize().then(() => {
			this.initalLoadTransactions();
		});
		this.handleDownloadUrlUpdate()
		
		this.vm.labels = {};
		this.vm.labels.col2 = this.vm.showIncomeOnly
			? this.angularFilterHelperService.translate('Wallet.Table.Status')
			: this.angularFilterHelperService.translate('Wallet.Table.Transaction');
		this.vm.labels.col4 = this.angularFilterHelperService.translate('Wallet.Table.Type');
		this.vm.labels.col5 = this.vm.showIncomeOnly
			? this.angularFilterHelperService.translate('Wallet.Table.Net')
			: this.angularFilterHelperService.translate('Wallet.Table.Amount');
		
		setTimeout(() => {
			this.loadAfterSessionReady();
		}, 200);
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	initalLoadTransactions() {
		if (this.session.getSession() && this.session.getSession().user) {
			this.vm.user = this.session.getSession().user;
			this.loadTransactions(true, true);
		} else {
			setTimeout(() => {
				this.initalLoadTransactions();
			}, 200);
		}
	}
	
	loadAfterSessionReady() {
		if (this.session.getSession() && this.session.getSession().user) {
			this.vm.user = this.session.getSession().user;
			if (this.vm.user.businessUser) {
				switch (this.vm.user.businessUserType) {
					case 'BUSINESS_CLIENT':
						this.vm.labels.col4 = this.angularFilterHelperService.translate('Wallet.Table.Worker_Code');
						var currentFilterData = {};
						this.watcher = this.angularHelperService.createInterval(() => {
							if (!this.angularHelperService.isEqual(this.vm.filterData, currentFilterData)) {
								this.handleFilterDataUpdate(this.vm.filterData, currentFilterData);
								currentFilterData = Object.assign({}, this.vm.filterData);
							}
						}, 500);
						break;
					case 'SERVICE_OWNER':
						this.vm.labels.col4 = this.angularFilterHelperService.translate('Wallet.Table.Patient_Code');
						break;
					default:
						this.vm.labels.col4 = this.angularFilterHelperService.translate('Wallet.Table.User_Code');
				}
			}

			this.broadcastSubscriptions.push(
				this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
					if (!this.vm.endReached) {
						this.loadTransactions();
					}
				})
			);
			this.broadcastSubscriptions.push(
				this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Wallet.FUNDS_ADDED, () => {
					this.loadTransactions(true);
					this.vm.currentPage = 0;
					this.currentPageChange.emit(this.vm.currentPage);
				})
			);
		} else {
			setTimeout(() => {
				this.loadAfterSessionReady();
			}, 200);
		}
	}

	handleFilterDataUpdate(nv, ov) {
		if (this.angularHelperService.equals(nv, ov) || !nv) return;
		var newFilter: any = nv || { created: {} };
		var oldFilter: any = ov || { created: {} };
		if (oldFilter.created && newFilter.created.start == oldFilter.created.start && newFilter.created.end == oldFilter.created.end) return;

		this.vm.createdStart = newFilter.created.start ? moment(newFilter.created.start).format('YYYY-MM-DD') : null;
		this.vm.createdEnd = newFilter.created.end ? moment(newFilter.created.end).format('YYYY-MM-DD') : null;
		this.handleDownloadUrlUpdate();

		this.vm.loading = true;
		this.loadTransactions(true, true);
	}
	
	handleDownloadUrlUpdate() {
		var url: any = this.config.getRestUrl() + 'rest/business/transaction/transaction-report.csv';
		var params: Array<any> = [];
		if (this.vm.showIncomeOnly) params.push('excludeCancelled=true');
		if (this.vm.createdStart) params.push('createdStart=' + this.vm.createdStart);
		if (this.vm.createdEnd) params.push('createdEnd=' + this.vm.createdEnd);
		
		this.vm.csvDownloadUrl = url + (params.length ? '?' + params.join('&') : '');
	}
	
	loadTransactions(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.transactions) ? this.vm.transactions.length : 0
		};
		if (this.vm.showIncomeOnly) {
			params['direction'] = 'INCOMING';
		}
		if (this.vm.showIncomeOnly) {
			params['excludeCancelled'] = this.vm.showIncomeOnly;
		}
		if (this.vm.createdStart) {
			params['createdStart'] = this.vm.createdStart;
		}
		if (this.vm.createdEnd) {
			params['createdEnd'] = this.vm.createdEnd;
		}
		
		this.serviceRestServices.getTransactions(params, (transactions) => {
			if (transactions && transactions.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			transactions.map((item) => {
				if (this.vm.user && this.vm.user.businessUser) {
					this.categoryService.getTranslation(item.booking.service).then((category) => {
						item.col3 = (item.booking.user.firstname || item.user.firstname)
							+ ' ' + (item.booking.user.lastname || item.user.lastname);
						if (this.vm.user.businessUserType === 'BUSINESS_CLIENT' || this.vm.user.businessUserType === 'SERVICE_OWNER') {
							item.col3 += ' (' + category + ')';
						}
						item.col4 = item.booking.user.userCode;
					});
				} else {
					switch (item.type) {
						case 'REFUND':
							item.col3 = this.angularFilterHelperService.translate('Wallet.Table.Refund_To_Bank');
							break;
						default:
							item.col3 = (item.direction === 'INCOMING' && item.status !== 'CANCELLED')
								? this.angularFilterHelperService.translate('Wallet.Table.Transfer_To_Wallet')
								: this.angularFilterHelperService.translate('Wallet.Table.Consultation')
									+ ': ' + item.booking?.service?.user?.firstname + ' ' + item.booking?.service?.user?.lastname;
					}
					item.col4 = this.angularFilterHelperService.translate('Wallet.Table.' + item.type);
				}
				
				if (this.vm.showIncomeOnly) {
					item.col2 = item.wired
						? this.angularFilterHelperService.translate('Wallet.Table.Wired')
						: this.angularFilterHelperService.translate('Wallet.Table.Not_Wired');
					item.col5 = (item.direction === 'INCOMING' ? '+' : '-') + (item.amount - item.fee);
				} else {
					item.col2 = this.angularFilterHelperService.translate('Wallet.Table.' + item.status);
					item.col5 = (item.direction === 'INCOMING' ? '+' : '-') + item.amount;
				}
			});
			if (isInitial) this.vm.currentPage = 0;
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.transactions = isInitial ? transactions : this.vm.transactions.concat(transactions);
					this.transactionsChange.emit(this.vm.transactions);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.transactions = isInitial ? transactions : this.vm.transactions.concat(transactions);
				this.transactionsChange.emit(this.vm.transactions);
			}
		});
	}
	
}